import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import '@/styles/WaitlistModal.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const WaitlistModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: ''
  });
  const [submitting, setSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    
    try {
      await axios.post(`${API}/waitlist`, formData);
      toast.success('Thanks for joining! We\'ll notify you when Straly launches.');
      setFormData({ name: '', email: '' });
      onClose();
    } catch (error) {
      toast.error('Failed to join waitlist. Please try again.');
      console.error('Waitlist error:', error);
    } finally {
      setSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose} data-testid="modal-overlay">
      <div className="modal-content" onClick={(e) => e.stopPropagation()} data-testid="modal-content">
        <button className="modal-close" onClick={onClose} data-testid="modal-close">
          <X size={24} />
        </button>
        
        <h2 className="modal-title" data-testid="modal-title">Join the Expert Marketing Strategy Waitlist</h2>
        <p className="modal-description" data-testid="modal-description">
          Be the first to know when Expert Marketing Strategy launches. Get early access and exclusive updates.
        </p>
        
        <form className="waitlist-form" onSubmit={handleSubmit} data-testid="waitlist-form">
          <Input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleInputChange}
            required
            data-testid="input-waitlist-name"
          />
          <Input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleInputChange}
            required
            data-testid="input-waitlist-email"
          />
          <Button 
            type="submit" 
            className="waitlist-submit-btn" 
            disabled={submitting}
            data-testid="submit-waitlist"
          >
            {submitting ? 'Joining...' : 'Join Waitlist'}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default WaitlistModal;
